/**
 * Returns the full display name for a provider object.
 * Handles missing middle names gracefully.
 * @param {Object|null} provider
 * @returns {string}
 */
export function formatProviderName (provider) {
  if (!provider) return ''
  return [provider.firstName, provider.middleName, provider.lastName]
    .filter(Boolean)
    .join(' ')
}
